import React from "react";

function CellGroup(props: { children?: React.ReactNode; className?: string }) {
  const { children, className } = props;

  const clonedChildren = React.Children.toArray(children).flatMap(
    (child, index, array) => {
      const elements = [];
      if (React.isValidElement(child)) {
        elements.push(
          React.cloneElement(
            child as React.ReactElement<{ className?: string }>,
            child.props
          )
        );
      } else {
        elements.push(child);
      }

      // 如果不是最后一个元素，添加分割线
      if (index < array.length - 1) {
        elements.push(
          <div key={`divider-${index}`} className="w-full h-0.25 bg-#ECEEF3" />
        );
      }

      return elements;
    }
  );

  return (
    <div
      className={`flex flex-col justify-center rd-3 bg-mx-white ${className}`}
    >
      {clonedChildren}
    </div>
  );
}

export default CellGroup;
